import { Component, Inject, Input, OnDestroy, OnInit, Optional } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { TranslateService, TranslateModule } from "@ngx-translate/core";
import { DeviceDetectService } from "../../services/device-detect.service";
import { NgStyle } from "@angular/common";


@Component({
    selector: "app-verification-modal",
    templateUrl: "./verification-modal.component.html",
    styleUrls: ["./verification-modal.component.css"],
    imports: [NgStyle, TranslateModule]
})
export class VerificationModalComponent implements OnInit, OnDestroy {
  @Input() verifCode: string;
  @Input() secondsToCountDown: number;
  timeOutText: string;
  i: number;
  isMobile: boolean;

  setInterval;

  constructor(
    private translate: TranslateService,
    private dialogRef: MatDialogRef<VerificationModalComponent>,
    private deviceDetectService: DeviceDetectService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data,
  ) {
    this.verifCode = this.data.verifCode;
    this.secondsToCountDown = this.data.secondsToCountDown;
  }

  ngOnInit(): void {
    this.setTimer(this.secondsToCountDown);
    this.isMobile = this.deviceDetectService.isMobile;
  }

  setTimer(secondsToCountDown: number) {
    this.i = secondsToCountDown;
    let timeOutMs = secondsToCountDown * 1000;
    setTimeout(() => {
      clearInterval(this.setInterval);
      this.dialogRef.close();
    }, timeOutMs);
    this.setInterval = setInterval(() => {
      this.translate.instant("login.waiting");
      this.timeOutText = this.translate.instant("login.waiting") + this.i;
      this.i--;
    }, 1000);
  }

  onClose() {
    this.dialogRef.close();
    clearInterval(this.setInterval);
  }

  ngOnDestroy() {
    clearInterval(this.setInterval);
  }
}
